import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import MoonAccount from './MoonAccount'

interface MoonAccountModalProps extends BaseModalProps {}

export const MoonAccountModal: React.FunctionComponent<MoonAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <MoonAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
